import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ToastState {
  type: 'info' | 'success' | 'error' | 'warning';
  message: string;
  messageType: 'string' | 'html';
  open: boolean;
  autoHideDuration?: number | null;
  allowClose?: boolean;
}

const initialState: ToastState = {
  type: 'info',
  message: '',
  messageType: 'string',
  open: false,
  autoHideDuration: 2000,
  allowClose: true,
};

export const toastSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToastState: (state, action: PayloadAction<ToastState>) => {
      const { type, message, open, autoHideDuration, allowClose, messageType } =
        action.payload;
      state.type = type;
      state.message = message;
      state.messageType = messageType || 'string';
      state.open = open;
      state.autoHideDuration = autoHideDuration;
      state.allowClose = allowClose;
    },
  },
});

export const { setToastState } = toastSlice.actions;

export default toastSlice.reducer;
